import { render, staticRenderFns } from "./RunningDataTable.vue?vue&type=template&id=279ba914"
import script from "./RunningDataTable.vue?vue&type=script&lang=js"
export * from "./RunningDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports